import React from "react";
import { ShieldCheck } from "lucide-react";

const PrivacyPolicy = () => {
  return (
    <div className="bg-[#0C2340] p-2 md:!p-6 flex flex-col items-center">
      
      <div className="w-full bg-white/10 backdrop-blur-md shadow-xl rounded-2xl p-8 border border-white/20">
      <h1 className=" text-3xl md:text-3xl font-extrabold text-center mb-8 flex items-center text-blue-300">
        <ShieldCheck className="mr-3 text-blue-300" size={35} /> Privacy Policy
      </h1>
        <p className="text-gray-100 text-lg leading-relaxed mb-6">
          We value your privacy and ensure that your data is protected. This policy explains how we collect, use, and safeguard your information. We may collect personal information such as name, email, phone number, and browsing data for better service.
          Your data will never be sold or misused, and we ensure compliance with global data protection regulations. We also use secure encryption protocols to protect sensitive information from unauthorized access.
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-blue-300 mb-4 border-b border-blue-300 pb-2">Information We Collect</h2>
        <ul className="text-gray-100 text-lg leading-relaxed mb-6 list-disc pl-6">
          <li>Personal Information: Name, email address, phone number, etc.</li>
          <li>Usage Data: IP address, browser type, pages visited, time spent on pages, etc.</li>
          <li>Cookies and Tracking Technologies to enhance user experience.</li>
        </ul>
        <h2 className="text-2xl md:text-3xl font-bold text-blue-300 mb-4 border-b border-blue-300 pb-2">We Use Your Information</h2>
        <ul className="text-gray-100 text-lg leading-relaxed mb-6 list-disc pl-6">
          <li>To provide, operate, and maintain our services.</li>
          <li>To personalize user experience and improve our website.</li>
          <li>To communicate with you, including responding to inquiries and providing updates.</li>
          <li>To enforce our terms, conditions, and policies.</li>
        </ul>
        <h2 className="text-2xl md:text-3xl font-bold text-blue-300 mb-4 border-b border-blue-300 pb-2">Security of Information</h2>
        <p className="text-gray-100 text-lg leading-relaxed mb-6">
          We implement a variety of security measures to maintain the safety of your personal information. Encryption, access control, and secure networks are used to protect against unauthorized access, alteration, or disclosure of your data.
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-blue-300 mb-4 border-b border-blue-300 pb-2">Your Rights and Choices</h2>
        <ul className="text-gray-100 text-lg leading-relaxed mb-6 list-disc pl-6">
          <li>You have the right to access, update, or delete your personal data.</li>
          <li>You can opt-out of marketing communications at any time.</li>
          <li>You can manage cookie preferences through your browser settings.</li>
        </ul>
        <h2 className="text-2xl md:text-3xl font-bold text-blue-300 mb-4 border-b border-blue-300 pb-2">Changes Privacy Policy</h2>
        <p className="text-gray-100 text-lg leading-relaxed">
          We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date. We encourage you to review this policy periodically to stay informed about how we are protecting your data.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;